//#region ENUM AutoOrderNotificationItemErrorReasonEnum

/**
 * Reason codes for per-item auto-order notification failures.
 */
export enum AutoOrderNotificationItemErrorReasonEnum {
  itemOnHold = 'itemOnHold',
  itemNotFound = 'itemNotFound',
  iqProcessingError = 'iqProcessingError',
  unknownError = 'unknownError',
}

//#endregion

//#region INTERFACE IAutoOrderNotificationItemError

/**
 * Item-level error payload on failed auto-order notifications and order documents.
 */
export interface IAutoOrderNotificationItemError extends Object {
  desc: string;
  error: number;
  reason: AutoOrderNotificationItemErrorReasonEnum | string;
}

//#endregion

//#region INTERFACE IAutoOrderNotificationItemErrorEntry

/**
 * Resolved failing item row for notification UI display.
 */
export interface IAutoOrderNotificationItemErrorEntry extends Object {
  desc: string;
  guidance: string;
  reason: AutoOrderNotificationItemErrorReasonEnum | string;
  stockCode: string;
}

//#endregion

//#region INTERFACE IAutoOrderNotificationItemErrorGuidance

/**
 * Grouped user guidance for one or more items sharing the same reason.
 */
export interface IAutoOrderNotificationItemErrorGuidance extends Object {
  guidance: string;
  reason: AutoOrderNotificationItemErrorReasonEnum | string;
}

//#endregion
